import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { Button, ButtonGroup } from "aible";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import numeral from "numeral";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleNotch, faDatabase, faMagic, faTrash } from "@fortawesome/free-solid-svg-icons";

import Select from "react-select";
import TransformIcon from "images/Next-Icons/TransformIcon.svg";
import JoinIcon from "images/Next-Icons/JoinIcon.svg";
import DropIcon from "images/Next-Icons/DropIcon.svg";
import ExploreIcon from "images/Next-Icons/ExploreIcon.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";
import BlueprintIcon from "images/Next-Icons/BlueprintIcon.svg";
import DataIcon from "images/DataIconGreen.svg";
import DataIconWhite from "images/DataIconWhite.svg";
import CompassIcon from "images/Next-Icons/CompassIcon.svg";
import ChecklistIcon from "images/Next-Icons/ChecklistIcon.svg";
import QuestionIcon from "images/Next-Icons/QuestionIcon.svg";
import SoundwaveIcon from "images/Next-Icons/SoundwaveIcon.svg";
import WorkerIcon from "images/Next-Icons/WorkerIcon.svg";
import CheckmarkIcon from "images/Next-Icons/CheckmarkIcon.svg";
import HexIconBackground from "images/Next-Icons/HexIconBackground.svg";
import OppositeArrowsIcon from "images/Next-Icons/OppositeArrowsIcon.svg";
import PurpleMagnifierIcon from "images/Next-Icons/PurpleMagnifier.svg";
import WandIcon from "images/Next-Icons/WandIcon.svg";
import LightWaypointIcon from "images/Next-Icons/LightWaypointIcon.png";
import LightExpertIcon from "images/Next-Icons/LightExpertIcon.png";
import LightResumeIcon from "images/Next-Icons/LightResumeIcon.png";

import ExpertIcon from "images/Next-Icons/ExpertIcon.svg";
import ResumeIcon from "images/Next-Icons/ResumeIcon.svg";

import PurpleCompassIcon from "images/Next-Icons/PurpleCompassIcon.svg";

import TransformBlueprintIcon from "images/Next-Icons/TransformBlueprintIcon.svg";
import TransformTrainIcon from "images/Next-Icons/TransformTrainIcon.svg";
import TransformAskExpertIcon from "images/Next-Icons/TransformAskExpertIcon.svg";
import TransformTransformIcon from "images/Next-Icons/TransformTransformIcon.svg";
import TransformExploreIcon from "images/Next-Icons/TransformExploreIcon.svg";

import SoundwaveIconColor from "images/Next-Icons/SoundwaveIconColor.svg";
import CompassIconColor from "images/Next-Icons/CompassIconColor.svg";
import ChecklistIconColor from "images/Next-Icons/ChecklistIconColor.svg";
import WorkerIconColor from "images/Next-Icons/WorkerIconColor.svg";

import HexGridContainer from "containers/Next/HexGrid";

import * as nextReducer from "containers/Next/NextReducer";

import styles from "./style.module.css";
import { LineInput } from "@/components/Inputs/LineInput";

export default class TransformNext extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      nextReducer.centerHex({ x: 8, y: 8 });
    }, 100);

    setTimeout(() => {
      nextReducer.centerHex({ x: 8, y: 8 });
    }, 500);

    setTimeout(() => {
      nextReducer.centerHex({ x: 8, y: 8 });
    }, 1000);
  }

  renderMinimap(node) {
    const { deleteExplorationNode } = this.props;

    return (
      <div className={styles.minimap}>
        <div className={styles.delButton}>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              deleteExplorationNode(node);
            }}
            style={{ padding: "10px" }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
        <div className={styles.eIcon}>
          <img
            style={node?.gridType === "Reduced" ? { borderRadius: "0px" } : {}}
            src={
              node?.gridType === "Default"
                ? CompassIconColor
                : node?.gridType === "ModelDriver"
                  ? SoundwaveIconColor
                  : node?.gridType === "Reduced"
                    ? ChecklistIconColor
                    : node?.gridType === "Empty"
                      ? WorkerIconColor
                      : CompassIconColor
            }
          />
        </div>
        <div className={styles.mGrid}>
          <HexGridContainer id={node?.nextId} explorationId={node?.explorationId} isMini isTile hexMap={node?.hexMap} />
        </div>
      </div>
    );
  }

  renderSetupText(node) {
    const { optimized, dataset, setup } = this.props;

    const rSetup = node?.afterSetup || setup || {};

    const subgroup = rSetup.splitColumn;
    const ignoredColumnCount = rSetup.ignored ? Object.keys(rSetup.ignored).length : 0;
    const ignoredValueCount = rSetup.ignoredValue ? Object.keys(rSetup.ignoredValue).length : 0;

    const baselineCount = rSetup.baselineCounts
      ? rSetup.baselineCounts?.truePositive +
        rSetup.baselineCounts?.falsePositive +
        rSetup.baselineCounts?.trueNegative +
        rSetup.baselineCounts?.falseNegative
      : rSetup.truePositive + rSetup.falsePositive + rSetup.trueNegative + rSetup.falseNegative;

    const totalCount = rSetup.truePositive + rSetup.falsePositive + rSetup.trueNegative + rSetup.falseNegative;

    const outcomePct =
      optimized?.outcomePercentage || rSetup.truePositive / (rSetup.truePositive + rSetup.falsePositive);
    const oOutcomePct =
      optimized?.originalOutcomePercentage ||
      optimized?.outcomePercentage ||
      rSetup.truePositive / (rSetup.truePositive + rSetup.falsePositive);

    const bStyle = {
      fontWeight: "bold",
      marginLeft: "3px",
      marginRight: "3px"
    };

    return node.leftSection === "STRATEGY" ? (
      <div>
        <span>{"My overall goal is to reach"}</span>
        <span style={bStyle}>{"Revenue"}</span>
        <span>{"of at least"}</span>
        <span style={bStyle}>{"110%"}</span>
        <span>{"of baseline ($" + 110223.01 + ")"}</span>
      </div>
    ) : node.leftSection === "BASELINE" ? (
      <div style={{ marginLeft: "10px", marginRight: "10px" }}>
        <span>{"Every"}</span>
        <span style={bStyle}>{"Month"}</span>
        <span>{"the AI will predict"}</span>
        <span style={bStyle}>{baselineCount + " Records"}</span>
        <span>{"with a"}</span>
        <span style={bStyle}>{oOutcomePct ? oOutcomePct.toFixed(2) * 100 + "%" : "?"}</span>
        <span>{"potential"}</span>
        <div>
          <span style={bStyle}>{"Success"}</span>
          <span>{"rate"}</span>
        </div>
      </div>
    ) : node.leftSection === "EXPECTED" ? (
      baselineCount === totalCount && outcomePct === oOutcomePct ? (
        <div>
          <div>{"I expect my future monthly behavior and business costs to remain the same as my baseline"}</div>
        </div>
      ) : (
        <div style={{ marginLeft: "10px", marginRight: "10px" }}>
          <span>{"Every"}</span>
          <span style={bStyle}>{"Month"}</span>
          <span>{"I expect"}</span>
          <span style={bStyle}>{totalCount + " Records"}</span>
          <span>{"with a"}</span>
          <span style={bStyle}>{outcomePct ? outcomePct.toFixed(2) * 100 + "%" : "?"}</span>
          <span>{"potential"}</span>
          <div>
            <span style={bStyle}>{"Success"}</span>
            <span>{"rate"}</span>
          </div>
        </div>
      )
    ) : node.leftSection === "SUBGROUP" || node.leftSection === "OUTCOME" ? (
      <div>
        <div>
          <span>{"Outcome: "}</span>
          <span style={bStyle}>{dataset?.outcome}</span>
        </div>
        {subgroup ? (
          <div>
            <span>{"Subgroup: "}</span>
            <span style={bStyle}>{subgroup}</span>
          </div>
        ) : (
          <div style={{ whiteSpace: "nowrap" }}>{"No Subgroup Selected"}</div>
        )}
        <div>
          <span style={bStyle}>{ignoredColumnCount}</span>
          <span>{"Columns ignored"}</span>
        </div>
        <div>
          <span style={bStyle}>{ignoredValueCount}</span>
          <span>{"Values ignored"}</span>
        </div>
      </div>
    ) : (
      <div />
    );
  }

  renderModelText() {
    const { modelCount } = this.props;

    return modelCount === 0 ? "Training AI Models..." : modelCount + " AI Models Created";
  }

  renderCreating() {}

  renderModelNode(node, hex) {
    const {
      projects,
      isCreating,
      updateSelectedHex,
      isContinuous,
      isForecastProject,
      setup,
      forecastPeriods,
      updateForecastPeriods
    } = this.props;

    let project = projects[node?.success?.value];

    const calcContinuousImpact = () => {
      const {
        optimized,

        modelGroups,
        showSubgroup,
        runId,
        setup
      } = this.props;
      let nTotalProfit = 0;
      const activeSlice =
        modelGroups &&
        modelGroups.drilldownValues &&
        modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
          ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
          : undefined;
      const isOverall = (activeSlice && activeSlice.value === "Overall") || showSubgroup;
      const nExpectedContinuousValue = Number(
        isOverall && optimized ? optimized.overallExpectedContinuousValue : setup.expectedValueContinuous
      );
      const nExpectedContinuousCount = Number(
        isOverall && optimized ? optimized.overallExpectedContinuousCount : setup.expectedCountContinuous
      );
      const nOverallContinuousPercent = Number(
        isOverall && optimized ? optimized.overallContinuousPercent : setup.continuousPercent
      );

      const nPotentialProfit = nExpectedContinuousValue * nExpectedContinuousCount * nOverallContinuousPercent;
      const bMetrics =
        activeSlice && activeSlice.bestModel && activeSlice.bestModel.metrics
          ? activeSlice.bestModel.metrics
          : optimized
            ? {
                underImpact: optimized.underEstimate,
                overImpact: optimized.overEstimate
              }
            : undefined;
      nTotalProfit = bMetrics ? nPotentialProfit - (bMetrics.underImpact + bMetrics.overImpact) : 0;

      return nTotalProfit;
    };

    return project === undefined && isCreating !== true ? (
      <div className={styles.createAIHex}>
        {/* <div className={styles.cIcon}>
          <FontAwesomeIcon icon={faMagic} />
        </div> */}
        <div
          className={styles.hexIconBackground}
          style={{
            backgroundImage: `url(${HexIconBackground})`,
            marginBottom: "0px"
          }}
        >
          <img src={WandIcon} />
        </div>
        <div className={styles.tDiv}>
          <span>{node.subText}</span>
          <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{node.boldText}</span>
          {node.leftSection === "FORECAST" && (
            <div className={"flex items-center"}>
              <div className={"text-[12px] mr-[8px]"}>{"Periods:"}</div>
              <LineInput
                value={forecastPeriods}
                onChange={(val) => updateForecastPeriods(val)}
                inputClassName={"text-[12px]"}
                min={1}
                max={52}
              />
            </div>
          )}
        </div>
        <div className={styles.hButton}>
          <Button type="primary" style={{ padding: "3px" }} onClick={() => updateSelectedHex(hex, node)}>
            {"Create AI"}
          </Button>
        </div>
      </div>
    ) : project?.bestModel === undefined || isCreating === true ? (
      <div>
        <div className={styles.loading}>
          <LoadingIndicator style={{ margin: "0px" }} />
        </div>
        <div>{"Creating AI"}</div>
        <div className={styles.tDiv}>
          <span>{node.subText}</span>
          <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{node.boldText}</span>
        </div>
      </div>
    ) : isForecastProject ? (
      <div>
        <div className={styles.pTitle}>{setup?.forecastTimeCol ? "Forecasted using " : "Forecasted"}</div>
        {setup?.forecastTimeCol ? <div className={styles.tTitle}>{setup?.forecastTimeCol}</div> : <React.Fragment />}
        {/* <div className={styles.tDiv}>
          <span style={{ fontWeight: "bold", marginRight: "3px" }}>
            {project?.stepsRemaining}
          </span>
          <span>{" Steps Not Completed."}</span>
        </div> */}
      </div>
    ) : (
      <div>
        <div className={styles.tTitle}>
          {isContinuous ? numeral(calcContinuousImpact()).format("0.0a") : numeral(project?.profit).format("0.0a")}
        </div>
        <div className={styles.pTitle}>{project?.netImpactLabel + " Found"}</div>
        {/* <div className={styles.tDiv}>
          <span style={{ fontWeight: "bold", marginRight: "3px" }}>
            {project?.stepsRemaining}
          </span>
          <span>{" Steps Not Completed."}</span>
        </div> */}
      </div>
    );
  }

  renderDatasetNode(dataset) {
    const { isDatasetFetching } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <div className={styles.dIcon}>
          {isDatasetFetching ? (
            <div className={styles.loading}>
              <LoadingIndicator style={{ margin: "0px" }} color={"#FFFFFF"} />
            </div>
          ) : (
            <img src={DataIconWhite} />
          )}
        </div>
        <div className={styles.dOverflow}>{dataset.label}</div>
      </div>
    );
  }

  renderOpenExplore() {
    return (
      <div className={styles.openExplore}>
        {"Building Exploration..."}
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    );
  }

  renderAddedBlueprint(node) {
    const { blueprints } = this.props;

    const blueprint = blueprints.find((b) => b.id === Number(node?.afterSetup?.blueprintId));

    return <div>{blueprint === undefined ? "No Blueprint Added" : "Blueprint Added: " + blueprint?.name}</div>;
  }

  renderAddJob(node) {
    const { updateIsCreateJob, handleBack } = this.props;

    return (
      <div
        className={styles.purpleTextIconHex}
        onClick={(e) => {
          e.stopPropagation();
          updateIsCreateJob(true);
        }}
      >
        <div
          className={styles.hexIconBackground}
          style={
            node?.text === "Post a job Automatically"
              ? {
                  /* backgroundImage: `url(${HexIconBackground})` */
                }
              : {}
          }
        >
          {/* <FontAwesomeIcon icon={faSearch} /> */}
          <img src={node?.text === "Post a job Automatically" ? ResumeIcon : LightResumeIcon} />
        </div>
        {node?.text}
        {/*"Post a New Job Automatically"*/}
        {/* <div className={styles.cSmall}>{"(Marketplace)"}</div> */}
      </div>
    );
  }

  renderAssignTask(node) {
    const { assignTodo } = this.props;

    return (
      <div
        className={styles.purpleTextIconHex}
        style={{ marginBottom: "20px" }}
        onClick={(e) => {
          e.stopPropagation();
          assignTodo({
            aTypeReadable: node?.text,
            mNode: node
          });
        }}
      >
        <div className={styles.hexIconBackground}>
          <img src={LightExpertIcon} />
        </div>
        {node?.text}
      </div>
    );
  }

  renderHex(hex, x, y, innerHexSize, node, isFaded = false, isDisabled = false, index = undefined) {
    const {
      projectId,
      datasetId,
      runId,
      dataset,
      updateSelectedHex,
      selectedHex,
      savedHexMap,
      handleBack,
      handleUpdate
    } = this.props;

    const isSelectedHex = selectedHex && selectedHex.x === hex.x && selectedHex.y === hex.y;
    //const hexSize = 128;

    const background = node?.background
      ? node?.background
      : node?.isPurple
        ? "rgba(126, 105, 215, 1)"
        : isSelectedHex
          ? "#E1FAFE"
          : node.parent || true
            ? "white"
            : node.color
              ? node.color
              : "#54C06C";
    /*
    const hoverColor =
      node.parent && node.color
        ? node.color
        : node.parent
        ? "#54C06C"
        : selectedHex && selectedHex.x === hex.x && selectedHex.y === hex.y
        ? "rgba(122, 109, 208, 1)"
        : "white";
        */

    const hoverColor = background === "white" ? "#7e69d7" : node.color ? node.color : "#54C06C";

    const textColor = node?.isPurple ? "white" : hoverColor;

    const hKey = hex.x + "_" + hex.y;

    const retProps = {
      id: projectId,
      runId: projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      isNext: true,
      isModelsNext: true,
      hideModel: true
    };

    const isCreateNode = node?.success?.value && node?.afterSetup === undefined;

    const isExploreLoadingNode = node?.leftSection === "OPEN_EXPLORE" && node?.isLoading === true;

    return (
      <div
        id={"hexTile_" + hKey + "_0"}
        key={"hex_" + (index !== undefined ? "_action" + index : hKey)}
        className={styles.hexHolder + " " + (isCreateNode ? styles.createHexHolder : "")}
        style={{
          left: x,
          top: y,
          opacity: isDisabled ? 0.4 : isFaded ? 0.3 : 1,
          pointerEvents: isFaded || isExploreLoadingNode ? "none" : "all"
        }}
        onClick={
          isExploreLoadingNode
            ? () => {}
            : isDisabled
              ? () => {}
              : isCreateNode
                ? () => {}
                : () => updateSelectedHex(hex, node)
        }
      >
        <div
          className={styles.hexagon}
          style={{
            height: innerHexSize + "px",
            width: innerHexSize * (110 / 190) + "px",
            background: background,
            cursor: isCreateNode ? "default" : "pointer"
          }}
        >
          {isSelectedHex && (
            <div className={styles.updateButtons}>
              <ButtonGroup>
                <Button
                  style={{ padding: "3px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBack();
                  }}
                >
                  {"Back"}
                </Button>
                {node?.hasUpdate === true && (
                  <Button
                    style={{ padding: "3px" }}
                    type="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdate(hex, node);
                    }}
                  >
                    {"Update"}
                  </Button>
                )}
              </ButtonGroup>
            </div>
          )}
          {savedHexMap[hKey] && node.isSave !== true && (
            <div className={styles.hexNumber} style={{ color: textColor }}>
              {savedHexMap[hKey].length}
            </div>
          )}
          {isExploreLoadingNode ? (
            this.renderOpenExplore(node)
          ) : node?.isPurple === true ? (
            <div className={styles.mainSection}>
              <div className={styles.sectionIconContainer}>
                <img
                  src={
                    node.icon === "Compass"
                      ? CompassIcon
                      : node.icon === "Checklist"
                        ? ChecklistIcon
                        : node.icon === "Expert"
                          ? LightExpertIcon
                          : node.icon === "Ai Training"
                            ? TrainIcon
                            : node.icon === "Soundwave"
                              ? SoundwaveIcon
                              : node.icon === "Worker"
                                ? WorkerIcon
                                : TransformIcon
                  }
                />
              </div>
              <div className={styles.sectionText}>
                {node?.afterSetup !== undefined && node?.afterText ? node?.afterText : node?.text}
              </div>
            </div>
          ) : (
            <div
              className={styles.hText}
              style={{
                height: innerHexSize + "px",
                width: innerHexSize * (110 / 190) + "px",
                color: textColor
              }}
            >
              {node && node.icon && (
                <div className={styles.iconHolder}>
                  <img
                    src={
                      node.icon === "Transform"
                        ? TransformTransformIcon
                        : node.icon === "Join"
                          ? JoinIcon
                          : node.icon === "Filter"
                            ? DropIcon
                            : node.icon === "Ai Training"
                              ? TransformTrainIcon
                              : node.icon === "Explore"
                                ? TransformExploreIcon
                                : node.icon === "Blueprint"
                                  ? LightWaypointIcon
                                  : null
                    }
                  />
                </div>
              )}
              {node?.icon === "OppositeArrows" && (
                <div className={styles.hexIconBackground} style={{ backgroundImage: `url(${HexIconBackground})` }}>
                  <img src={OppositeArrowsIcon} />
                </div>
              )}
              {node?.icon === "MagnifyingGlass" && (
                <div
                  className={styles.hexIconBackground}
                  //style={{ backgroundImage: `url(${HexIconBackground})` }}
                >
                  <img src={ExpertIcon} />
                </div>
              )}
              {node?.afterSetup !== undefined && node?.leftSection === "BLUEPRINT"
                ? this.renderAddedBlueprint(node)
                : node?.type === nextReducer.HEXAGON_NODES.ADD_JOB
                  ? this.renderAddJob(node)
                  : node?.success?.value
                    ? this.renderModelNode(node, hex)
                    : node.isCreateDisplayNode && node.isCreating
                      ? "Creating AI"
                      : node.afterSetup !== undefined && node.success !== undefined && node.afterText !== undefined
                        ? this.renderModelText()
                        : node && node.leftSection === "OPEN_EXPLORE"
                          ? this.renderMinimap(node)
                          : node && Array.isArray(node) && node.length > 0
                            ? node[0].parent.text
                            : node.text === "Dataset Name" && dataset
                              ? this.renderDatasetNode(dataset)
                              : node.text === "Dataset Name"
                                ? "..."
                                : node.text}
              {node && node.hasUpdate && node.leftSection === "STRATEGY" ? (
                <div className={styles.tDiv}>
                  <BusinessConstraintsContainer {...retProps} overviewOnly />
                </div>
              ) : false ? (
                <div className={styles.tDiv}>{this.renderSetupText(node)}</div>
              ) : (
                <div />
              )}
            </div>
          )}
          <div
            className={styles.face1}
            style={{
              background: background,
              cursor: isCreateNode ? "default" : "pointer"
            }}
          ></div>
          <div
            className={styles.face2}
            style={{
              background: background,
              cursor: isCreateNode ? "default" : "pointer"
            }}
          ></div>
        </div>
        <div className={styles.borderHex}>
          <div
            className={styles.hexagon}
            style={{
              height: innerHexSize + 6 + "px",
              width: innerHexSize * (110 / 190) + (6 * 110) / 190 + "px",
              background: hoverColor
            }}
          >
            <div
              className={styles.face1}
              style={{
                background: hoverColor
              }}
            ></div>
            <div
              className={styles.face2}
              style={{
                background: hoverColor
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { id, projectId, isExploreReady, hexMap, actionHexMap, savedHexMap, selectedHex, hexSize } = this.props;

    const retHexMap = Object.fromEntries(Object.entries(hexMap).filter(([_, v]) => v?.type !== "Expert"));

    let hexGrid = [];

    const calcInnerHexSize = (size) => size * 1.65;
    const innerHexSize = calcInnerHexSize(hexSize);

    const Hex = extendHex({
      size: hexSize, // default: 1
      orientation: "flat" // default: 'pointy'
    });

    const Grid = defineGrid(Hex);

    const hasActions = actionHexMap && Object.keys(actionHexMap).length > 0;

    Grid.hexagon({
      radius: 8,
      center: [8, 8]
    }).forEach((hex, i) => {
      const { x, y } = hex.toPoint();

      const rKey = hex.x + "_" + hex.y;

      if (actionHexMap && actionHexMap[rKey]) {
        if (projectId === undefined && actionHexMap[rKey]?.gridType === "ModelDriver") {
          hexGrid.push(
            <OverlayTrigger
              placement={"top"}
              trigger={["hover"]}
              overlay={
                <Popover id={"popover-positioned-top"}>
                  {"You must run models before you can create this exploration type."}
                </Popover>
              }
              key={"overlay_" + i}
            >
              {this.renderHex(hex, x, y, innerHexSize, actionHexMap[rKey], undefined, true)}
            </OverlayTrigger>
          );
        } else {
          hexGrid.push(this.renderHex(hex, x, y, innerHexSize, actionHexMap[rKey], undefined, undefined, i));
        }
      } else if (savedHexMap && savedHexMap[rKey]) {
        hexGrid.push(this.renderHex(hex, x, y, innerHexSize, savedHexMap[rKey], hasActions, false));
      } else if (retHexMap && retHexMap[rKey]) {
        if (retHexMap[rKey]?.gridType === "Explore" && !isExploreReady) {
          hexGrid.push(
            <OverlayTrigger
              placement={"top"}
              trigger={["hover"]}
              overlay={
                <Popover id={"popover-positioned-top"}>
                  {"You must wait for the initial target analysis to complete before you can explore."}
                </Popover>
              }
              key={"overlay_" + i}
            >
              {this.renderHex(
                hex,
                x,
                y,
                innerHexSize,
                retHexMap[rKey],
                hasActions && (selectedHex === undefined || selectedHex.x !== hex.x || selectedHex.y !== hex.y),
                true
              )}
            </OverlayTrigger>
          );
        } else {
          hexGrid.push(
            this.renderHex(
              hex,
              x,
              y,
              innerHexSize,
              retHexMap[rKey],
              hasActions && (selectedHex === undefined || selectedHex.x !== hex.x || selectedHex.y !== hex.y)
            )
          );
        }
      }
    });

    return hexGrid;
  }
}
